import PsychologyIcon from '@mui/icons-material/Psychology'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import GroupIcon from '@mui/icons-material/Group'
import VerifiedIcon from '@mui/icons-material/Verified'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import BusinessIcon from '@mui/icons-material/Business'

function LandingFeatures () {
  return (
    <section className='lp-solution-section'>
      <div className='lp-section-content'>
        <div className='lp-solution-intro'>
          <h2 className='lp-section-title'>
            Ihre Lösung: Engineers Knowledge Base
          </h2>
          <p className='lp-section-subtitle'>
            Speziell entwickelt für Servicetechniker in
            technologieorientierten Unternehmen
          </p>
        </div>

        <div className='lp-features-grid' id='features'>
          <div className='lp-feature-card'>
            <div className='lp-feature-icon'>
              <PsychologyIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>KI-gestützte Suche</h3>
            <p>
              Intelligente Abfrage mit AI – finden Sie Lösungen in Sekunden
              statt Stunden. Einfach in natürlicher Sprache fragen.
            </p>
          </div>

          <div className='lp-feature-card'>
            <div className='lp-feature-icon'>
              <MenuBookIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Zentrale Wissensdatenbank</h3>
            <p>
              Alle Troubleshooting-Guides, Fehlercodes, Wartungsanleitungen
              und Workarounds an einem Ort.
            </p>
          </div>

          <div className='lp-feature-card'>
            <div className='lp-feature-icon'>
              <GroupIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Einfacher Wissensaustausch</h3>
            <p>
              Techniker teilen Erfahrungen direkt in der App. Mit Bildern,
              Kommentaren und Schritt-für-Schritt-Anleitungen.
            </p>
          </div>

          <div className='lp-feature-card'>
            <div className='lp-feature-icon'>
              <VerifiedIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Qualitätssicherung</h3>
            <p>
              Moderatoren prüfen neue Beiträge. So bleibt Ihre Wissensbasis
              hochwertig und vertrauenswürdig.
            </p>
          </div>

          <div className='lp-feature-card'>
            <div className='lp-feature-icon'>
              <EmojiEventsIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Gamification</h3>
            <p>
              Punkte, Levels und Bestenlisten motivieren Ihr Team, aktiv
              Wissen zu teilen und beizutragen.
            </p>
          </div>

          <div className='lp-feature-card'>
            <div className='lp-feature-icon'>
              <BusinessIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Multi-Tenant System</h3>
            <p>
              Perfekt für Unternehmen mit mehreren Standorten oder
              Abteilungen. Jede Einheit hat ihre eigene Wissensbasis.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingFeatures

